// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NavTopBarBody-base___TwHB{border-bottom:var(--size-0_25) solid var(--gray-a3)}.NavTopBarBody-base___TwHB .NavTopBarBody-container__aGCMS{position:relative;display:flex;flex-direction:column}@media only screen and (min-width: 64rem){.NavTopBarBody-base___TwHB .NavTopBarBody-container__aGCMS{flex-direction:row;gap:var(--size-2);align-items:center;justify-content:space-between}}@media only screen and (min-width: 64rem){.NavTopBarBody-base___TwHB{padding:var(--size-0) var(--size-4)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "NavTopBarBody-base___TwHB",
	"container": "NavTopBarBody-container__aGCMS"
};
export default ___CSS_LOADER_EXPORT___;
